import React from "react";
import { ICommonIconProps } from "../interface";

const SendIcon = ({ ...props }: ICommonIconProps) => {
  return (
    <svg
      width={props?.IconWidth || "20"}
      height={props?.IconHeight || "20"}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.5954 0.126175L0.487941 10.5694C-0.219166 10.9756 -0.129313 11.9597 0.573888 12.2566L4.72668 13.9984L15.9505 4.10975C16.1654 3.91838 16.4701 4.21129 16.2865 4.4339L6.87534 15.8964V19.0403C6.87534 19.962 7.98874 20.3252 8.53568 19.6574L11.0164 16.6385L15.8841 18.6771C16.4389 18.9115 17.0718 18.5639 17.1733 17.9663L19.9861 1.09473C20.119 0.305826 19.2712 -0.264372 18.5954 0.126175Z"
        fill={props?.IconColor || "currentColor"}
      />
    </svg>
  );
};

export default SendIcon;
